import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ServiceBagService, ServiceBagServices } from "../../../../../base/component/ServiceBag";
import { BaseState, CredentialType, CredentialLogin, WebAPICredential } from "../../../../../base/entities/BaseEntities";
import { BaseGridComponent } from "../../../../../base/component/BaseGridComponent";
import { ContextMenuElement } from "@m4u-angular/base/classes/BaseClasses";


@Component({
    providers: ServiceBagServices,
    selector: 'app-credential-login-history-grid',
    templateUrl: './credential-login-history-grid.component.html'
})
export class CredentialLoginHistoryGridComponent extends BaseGridComponent<CredentialLogin, BaseState>{
    @Input() Credentials: any;
    @Input() CredentialsInfo: CredentialType[];
    @Output() OnRefresh = new EventEmitter<void>();

    constructor(A: ServiceBagService) {
        super(A, 'CredentialLoginHistoryGridComponent', CredentialLogin, BaseState);
    }

    protected override GetGridRowContextMenu(options?: any): ContextMenuElement[] {
        return [{
            text: this.RC('btnManageCredentials'),
            visible: !!options?.data?.CredentialID,
            onClick: () => this.Navigate(['/pages/passwordmanage'], { CredentialID: options.data.CredentialID })
        }, {
            text: this.RC('btnGoToRequestsHistory'),
            visible: true,
            onClick: () => this.Navigate(['pages/general/requests-history'], { CredentialID: options.data.CredentialID })
        }, {
            text: this.RC('btnGoToCredentialsReport'),
            visible: true,
            onClick: () => this.Navigate(['pages/general/credentials-report'], { CredentialID: options.data.CredentialID })
        }];
    }

    OnToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            isCustom: true,
            options: {
                icon: 'refresh',
                onClick: () => {
                    this.OnRefresh.emit();
                }
            }
        });
    }
}
